import { render, staticRenderFns } from "./updateCallback.vue?vue&type=template&id=b034f1d0&scoped=true&"
import script from "./updateCallback.vue?vue&type=script&lang=js&"
export * from "./updateCallback.vue?vue&type=script&lang=js&"
import style0 from "./updateCallback.vue?vue&type=style&index=0&id=b034f1d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b034f1d0",
  null
  
)

export default component.exports